import { forwardRef, createElement } from 'react';
import classNames from 'classnames';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Button = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var className = _ref.className,
      disabled = _ref.disabled,
      inProgress = _ref.inProgress,
      noBreak = _ref.noBreak,
      small = _ref.small,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "disabled", "inProgress", "noBreak", "small", "type"]);

  return /*#__PURE__*/createElement("button", _extends({}, props, {
    ref: forwardedRef,
    className: classNames('button', className, {
      'button--is-disabled': !inProgress && disabled,
      'button--in-progress': inProgress,
      'button--small': small,
      'button--no-break': noBreak
    }),
    disabled: disabled || inProgress,
    type: type
  }));
});
var CallToActionButton = /*#__PURE__*/forwardRef(function (_ref2, forwardedRef) {
  var className = _ref2.className,
      props = _objectWithoutPropertiesLoose(_ref2, ["className"]);

  return /*#__PURE__*/createElement(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classNames(className, 'button--cta')
  }));
});
var DefaultButton = /*#__PURE__*/forwardRef(function (_ref3, forwardedRef) {
  var className = _ref3.className,
      props = _objectWithoutPropertiesLoose(_ref3, ["className"]);

  return /*#__PURE__*/createElement(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classNames(className, 'button--default')
  }));
});
var OrderButton = /*#__PURE__*/forwardRef(function (_ref4, forwardedRef) {
  var className = _ref4.className,
      props = _objectWithoutPropertiesLoose(_ref4, ["className"]);

  return /*#__PURE__*/createElement(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classNames(className, 'button--order')
  }));
});
var DestructiveButton = /*#__PURE__*/forwardRef(function (_ref5, forwardedRef) {
  var className = _ref5.className,
      props = _objectWithoutPropertiesLoose(_ref5, ["className"]);

  return /*#__PURE__*/createElement(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classNames(className, 'button--destructive')
  }));
});
var DestructiveFlatButton = /*#__PURE__*/forwardRef(function (_ref6, forwardedRef) {
  var className = _ref6.className,
      props = _objectWithoutPropertiesLoose(_ref6, ["className"]);

  return /*#__PURE__*/createElement(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classNames(className, 'button--destructive-flat')
  }));
});
var FlatButton = /*#__PURE__*/forwardRef(function (_ref7, forwardedRef) {
  var className = _ref7.className,
      props = _objectWithoutPropertiesLoose(_ref7, ["className"]);

  return /*#__PURE__*/createElement(Button, _extends({}, props, {
    ref: forwardedRef,
    className: classNames(className, 'button--flat')
  }));
});
Button.displayName = "Button";
CallToActionButton.displayName = "CallToActionButton";
DefaultButton.displayName = "DefaultButton";
OrderButton.displayName = "OrderButton";
DestructiveButton.displayName = "DestructiveButton";
DestructiveFlatButton.displayName = "DestructiveFlatButton";
FlatButton.displayName = "FlatButton";

var LinkButton = /*#__PURE__*/forwardRef( // TODO: remove use of <Button /> here, instead render a <button /> ourselves?
// I don't think LinkButton supports in progress, for instance, but leaving as it was for now
function (_ref, forwardedRef) {
  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "type"]);

  return /*#__PURE__*/createElement(Button, _extends({}, props, {
    className: classNames(className, 'button--link'),
    ref: forwardedRef,
    type: type
  }));
});
LinkButton.displayName = "LinkButton";

export { Button, CallToActionButton, DefaultButton, DestructiveButton, DestructiveFlatButton, FlatButton, LinkButton, OrderButton };
//# sourceMappingURL=index.es.js.map
